var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.winner)?_c('div',{staticClass:"winner winner--final_2"},[_c('k-block',{attrs:{"name":"winners_final_2"}}),_c('k-user',{attrs:{"nick":_vm.winner.mobile,"logo":_vm.winner.logoSrc}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }